<template>
  <div class="row">
    <div class="col-12 col-md-6 d-flex">
      <div>
        <b-badge v-if="statusProposta" :variant="statusProposta.variante">
          {{ statusProposta.text }}
        </b-badge>
      </div>
      <div>
        <b-badge class="ml-2" variant="danger" v-if="propostaCongelada">
          <i :class="`fa-solid fa-lock mr-2`"></i>
          Proposta congelada
        </b-badge>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <b-button-group size="sm" style="float: right">
        <b-dropdown variant="info" right>
          <template #button-content>
            <i class="fas fa-file-pdf mr-2"></i>
            Relatório PDF
          </template>

          <b-dropdown-item @click="baixarPDF(false)"
            >Individual ({{
              empresasSelecionada.nomeFantasia
            }})</b-dropdown-item
          >
          <b-dropdown-item @click="baixarPDF(true)"
            >Consolidado (Todas empresas)</b-dropdown-item
          >
        </b-dropdown>
      </b-button-group>

      <b-button-group
        size="sm"
        class="mr-2"
        v-if="!ehExecutora"
        style="float: right"
      >
        <b-dropdown variant="info" right>
          <template #button-content>
            <i class="fas fa-file-excel mr-2"></i>
            Anexo 5
          </template>

          <b-dropdown-item @click="baixarExcel(false)"
            >Individual
          </b-dropdown-item>
          <b-dropdown-item @click="baixarExcel(true)"
            >Consolidado (Todas empresas)</b-dropdown-item
          >
        </b-dropdown>
      </b-button-group>

      <b-button
        @click="baixarExcel(false)"
        variant="info"
        class="mr-2"
        v-if="ehExecutora"
        style="float: right"
      >
        <i class="fas fa-file-excel mr-2"></i>
        Anexo 5
      </b-button>
    </div>

    <accordion
      v-for="accordion in gerarTelas()"
      :key="accordion.tela"
      class="col-12 mt-3"
      :hideTitle="!id"
      :id="accordion.tela"
      :title="accordion.titulo"
      @abriu="abriu(accordion.tela)"
    >
      <componentes
        :tela="accordion.tela"
        :proposta-id="id"
        :proposta-original-id="propostaIdBase"
        :duracao="duracao"
        @update="buscarProposta"
        :endpoint="config.endpoint"
        :aprovada="propostaAprovada || !propostaEditavel"
        :chave-permissao="accordion.chavePermissao"
        :ref="accordion.tela"
      />
    </accordion>
  </div>
</template>
<script>
import Accordion from "@/components/card/Accordion";
import Componentes from "./Componentes";
import ComponentesConfig from "./componentes.config";

import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";

import PropostaService from "@/common/services/proposta/proposta.service";
import ProjetoService from "@/common/services/projeto/projeto.service";
import helpers from "@/common/utils/helpers";
import { Excel } from "@/common/utils/excel";

export default {
  name: "PropostaDetalhamento",
  mixins: [AlertasMixin],
  props: {
    id: {
      required: true,
    },
    tipoProposta: {
      default: "executora",
    },
    texto: {
      default: "Proposta",
    },
    rota: {
      default: "proposta",
    },
  },
  components: {
    Accordion,
    Componentes,
  },
  data: () => ({
    propostaAprovada: false,
    propostaCongelada: false,
    propostaEditavel: true,
    statusProposta: null,
    proposta: null,
    propostaIdBase: null,
    duracao: null,
  }),
  methods: {
    abriu: function (tela) {
      /* eslint-disable */
      try {
        this.$refs[tela][0].montar(tela);
      } catch (e) {}
    },
    congelarProposta: function () {
      this.confirmar(
        `Deseja ${this.propostaCongelada ? "retomar" : "congelar"} a proposta?`
      ).then((confirmado) => {
        if (!confirmado) return;
        PropostaService.congelar(this.id, !this.propostaCongelada)
          .then(() => {
            this.alertaSucesso(
              `Proposta ${
                this.propostaCongelada ? "retomada" : "congelada"
              } com sucesso!`
            );
            this.buscarProposta();
          })
          .catch(() => {
            this.alertaErro(
              `Erro ao ${
                this.propostaCongelada ? "retomar" : "congelar"
              } proposta!`
            );
          });
      });
    },
    gerarTelas: function () {
      if (!this.proposta) return [];
      return this.config.componentes.filter((el) => {
        return this.permissao(el.chavePermissao).r;
      });
    },
    buscarProposta: function () {
      this.$store.dispatch(START_LOADING);
      PropostaService.buscarProposta(this.id)
        .then((response) => {
          this.proposta = response.data.data;
          if (this.ehExecutora) {
            this.propostaIdBase = response.data.data.id;

            this.propostaAprovada = response.data.data.aprovada;
            this.statusProposta = helpers.getEnum(
              response.data.data.statusExecutora
            ) || { text: "Sem status", variante: "danger" };
            this.propostaCongelada = response.data.data.congelada;
            this.propostaEditavel = response.data.data.editavel;
            this.duracao = response.data.data.descricaoTecnica.duracao;
          } else {
            this.propostaIdBase = response.data.data.proposta.id;

            this.propostaAprovada = response.data.data.proposta.aprovada;
            this.statusProposta = helpers.getEnum(
              response.data.data.proposta.statusExecutora
            ) || { text: "Sem status", variante: "danger" };
            this.propostaCongelada = response.data.data.proposta.congelada;
            this.propostaEditavel = response.data.data.proposta.editavel;
            this.duracao = response.data.data.proposta.descricaoTecnica.duracao;
          }
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    baixarExcel: function (consolidado = false) {
      this.$store.dispatch(START_LOADING);

      PropostaService.baixarAnexo5(this.id, consolidado)
        .then((res) => {
          let xmlString = res.data.data;
          let doc = new DOMParser().parseFromString(xmlString, "text/html");
          const ex = new Excel();

          for (let sheet of doc.getElementsByClassName("sheet")) {
            ex.adicionarSheet(sheet, sheet.getAttribute("nome-sheet"));
          }
          ex.baixarExcel("Anexo5.xlsx");
        })
        .catch(() => {
          this.alertaErro("Erro ao gerar excel!");
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    associarProposta: function () {
      this.$store.dispatch(START_LOADING);
      let form = {
        propostaId: this.propostaIdBase,
      };

      ProjetoService.novoProjeto(form)
        .then((res) => {
          this.alertaSucesso("Sucesso", "Projeto criado com sucesso").then(
            () => {
              this.$router.push({
                name: "projeto-detalhamento",
                params: { id: res.data.data },
              });
            }
          );
        })
        .catch((err) => {
          this.alertaErro(err.response.data.errors);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    baixarPDF: function (consolidado) {
      this.$store.dispatch(START_LOADING);
      PropostaService.relatorioConsolidadoPDF(this.id, consolidado)
        .then((res) => {
          this.$store.dispatch(STOP_LOADING);
          const blob = new Blob([res.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `Relatório ${
            consolidado ? "Consolidado" : this.empresasSelecionada.nomeFantasia
          }.pdf`;
          link.click();
        })
        .catch((err) => {
          this.alertaErro(err.response.data.errors);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },
  mounted() {
    PropostaService.setEndpoint(ComponentesConfig[this.tipoProposta].endpoint);

    this.$store.dispatch(DEFINIR_BREADCRUMB, [
      {
        titulo: this.ehAdmin ? "Propostas" : this.texto,
        to: { name: this.ehAdmin ? "proposta-todos-lista" : this.rota },
      },
      { titulo: this.id ? "Editar" : "Cadastrar" },
    ]);

    if (this.id) {
      this.buscarProposta();
    }
  },
  computed: {
    permissao() {
      return this.$store.getters["app/retornaPermissao"];
    },
    ehAdmin() {
      return this.$store.getters["app/ehAdmin"];
    },
    empresasSelecionada() {
      return this.$store.state.app.selectedCompanyObj;
    },
    config: function () {
      return ComponentesConfig[this.tipoProposta];
    },
    ehExecutora: function () {
      return this.$route.name == "proposta-executora-detalhamento";
    },
    ehProponente: function () {
      return this.$route.name == "proposta-proponente-detalhamento";
    },
    propostaObj: function () {
      if (!this.proposta) return null;

      if (this.ehExecutora) return this.proposta;

      return this.proposta.proposta;
    },
  },
  watch: {
    statusProposta: function (valor) {
      if (
        valor.value == "PropostaFechada" &&
        this.ehProponente &&
        !this.propostaObj.associada
      ) {
        this.confirmar(
          "Aviso",
          "A proposta já está com todos os investimentos efetuados. Deseja associa-la ao projeto?"
        ).then((confirmado) => {
          if (!confirmado) return;

          this.confirmar(
            "Aviso",
            "Deseja realmente criar um projeto a partir da proposta?"
          ).then((confirmado) => {
            if (!confirmado) return;

            this.associarProposta();
          });
        });
      }
    },
  },
};
</script>
<style>
</style>